import { Dialog, DialogContent } from "@/components/dialog"

/**
 * Base container component for swap dialogs.
 * Accepts child components that are rendered in order.
 * All business logic and state management should happen in parent components.
 */
export const SwapDialog: React.FC<{
  title: string
  description?: string
  minHeight?: number
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}> = ({ isOpen, onClose, children, description, minHeight: minHeight = 540, title }) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(value: boolean) => {
        if (!value) {
          onClose()
        }
      }}
    >
      <DialogContent
        title={title}
        description={description}
        className="swap-dialog relative min-w-[320px]"
        style={{ minHeight: `${minHeight}px` }}
      >
        {children}
      </DialogContent>
    </Dialog>
  )
}
